import React, {useEffect, useState} from "react";
import DetailImage from "../../components/DetailImage";
import {formatPortDate} from "../../utils/dateTimeUtils";
import {useSelector} from "react-redux";
import {getFromHubNew} from "../../actions/networkActions";
import {getTranslation} from "../../translations/translationUtils";
import PropTypes from "prop-types";
import VideoComponent from "../../components/VideoComponent";
import PdfItems from "../../components/PdfItems";
import {DefaultButtonLink, SecondaryButtonLinkExternal} from "../../resources/styles";
import {removeHtmlStyles} from "../../utils/stringUtils";
import {useTheme} from "styled-components";
import FullScreenLoader from "../../components/FullScreenLoader";

const Detail = ({match}, context) => {
    const configuration = useSelector(state => state.configuration);
    const itineraryExcursionLinkPath = useSelector(state => state.configuration?.hubSettings?.uiSettings?.itineraryExcursionLinkPath);

    const theme = useTheme();

    const id = match.params.id;

    const [detail, setDetail] = useState(null);
    const [videos, setVideos] = useState(null);
    const [pdfs, setPdfs] = useState(null);
    const [links, setLinks] = useState(null);

    useEffect(() => {
        getFromHubNew(
            `itinerary/schedules/${id}`,
            (data) => processSchedule(data)
        );
        getFromHubNew(
            `blobs/videos/${id}`,
            (data) => processVideos(data)
        );
        getFromHubNew(
            `blobs/pdfs/${id}`,
            (data) => setPdfs(data)
        );
    }, [id]);

    const processSchedule = (schedule) => {
        setDetail(schedule);
        const links = schedule.scheduleLinks
        if (Array.isArray(links) && links.length > 0) {
            setLinks(links);
        }
    }

    const processVideos = (videos) => {
        if (Array.isArray(videos) && videos.length > 0) {
            let videosArray = [];
            for (let i = 0; i < videos.length; i++) {
                const fullVideo = videos[i];
                fullVideo.urlFrontend = videos[i].urlFrontend;
                videosArray.push(fullVideo);
            }
            setVideos(videosArray);
        }
    }

    if (!detail) {
        return <FullScreenLoader />;
    }

    const arrives = getTranslation(detail.arrives);
    const allOnBoard = getTranslation(detail.allOnBoard);
    const departs = getTranslation(detail.departs);
    const title = getTranslation(detail.title);

    return (
        <div>
            <div className="grid-x grid-padding-x">
                <div className="cell small-12 medium-4 large-4">
                    <DetailImage image={configuration.hubUrl + "blobs/image?reference=" + detail.id}/>
                </div>
                <div className="cell small-12 medium-8 large-8 text-left">
                    <h1>{title}</h1>
                    <p>
                        <span>
                            <b>{context.t("date")}:</b> { formatPortDate(detail.date, theme.dateLocale) } <br/>
                        </span>
                        { arrives !== "" &&
                                <span>
                                    <b>{context.t("arrives")}:</b> {arrives}<br/>
                                </span>
                        }
                        { allOnBoard !== "" &&
                                <span>
                                    <b>{context.t("all_on_board")}:</b> {allOnBoard}<br/>
                                </span>
                        }
                        { departs !== "" &&
                                <span>
                                    <b>{context.t("departs")}:</b> {departs}<br/>
                                </span>
                        }
                    </p>
                    { itineraryExcursionLinkPath &&
                            <DefaultButtonLink to={{
                                pathname: `${itineraryExcursionLinkPath}${detail.date.replace(/\//g, "-")}`,
                                state: {
                                    portName: title,
                                    arrivalTime: arrives,
                                    departureTime: departs,
                                    portDate: detail.date
                                }
                            }}>
                                {context.t("view_experiences")}
                            </DefaultButtonLink>
                    }
                    { pdfs && <PdfItems items={pdfs}/> }
                    { links?.map((link) =>
                            <div className="block mb-2" key={link.id}>
                                <SecondaryButtonLinkExternal href={link.url} target="_blank">
                                    {getTranslation(link.name)}
                                </SecondaryButtonLinkExternal>
                            </div>
                        )
                    }
                    <div className="margin-top-1">
                        <p dangerouslySetInnerHTML={{__html: removeHtmlStyles(getTranslation(detail.description))}}></p>
                    </div>
                    { videos && <VideoComponent videoItems={videos}/> }
                </div>
            </div>
        </div>
    );
}

Detail.contextTypes = {
    t: PropTypes.func.isRequired,
};

export default Detail;
